(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lamy-store-stock"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lamy-store-stock')) return;

    class LamyStoreStock extends HTMLElement {
      connectedCallback() {
        this.rendered = null;
        this.onVariant = () => this.sync();
        document.addEventListener('variant:update', this.onVariant);
        this.timer = setInterval(() => this.sync(), 700);
        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        clearInterval(this.timer);
      }

      get map() {
        const el = this.querySelector('[data-lamy-ss-json]');
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return null;
        }
      }

      get stale() {
        const maxAge = Number(this.dataset.maxAge || 0);
        const synced = Number(this.dataset.synced || 0);
        if (!synced) return true;
        if (!maxAge) return false;
        return Date.now() / 1000 - synced > maxAge * 3600;
      }

      currentVariantId() {
        const root = this.closest('[id^="shopify-section"]') || document;
        const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (input && input.value) return String(input.value);
        return String(this.dataset.variant || '');
      }

      sync() {
        const id = this.currentVariantId();
        const key = id + (this.stale ? ':stale' : '');
        if (!id || key === this.rendered) return;
        this.render(id);
        this.rendered = key;
      }

      render(id) {
        const map = this.map;
        if (!map) return;
        const stale = this.stale;
        const code = map[id] || '0000';
        const labels = {
          in: this.dataset.labelIn,
          low: this.dataset.labelLow,
          out: this.dataset.labelOut,
          call: this.dataset.labelCall,
        };
        let inCount = 0;
        let unknown = 0;

        this.querySelectorAll('[data-lamy-ss-store]').forEach((li) => {
          const idx = Number(li.dataset.idx);
          const show = li.dataset.show === 'true' && idx >= 0 && !stale;
          let state = 'call';
          if (show) {
            const digit = code.charAt(idx);
            state = digit === '2' ? 'in' : digit === '1' ? 'low' : 'out';
            if (state !== 'out') inCount += 1;
          } else {
            unknown += 1;
          }
          const badge = li.querySelector('[data-lamy-ss-badge]');
          if (badge) {
            badge.dataset.state = state;
            badge.textContent = labels[state] || '';
          }
        });

        const summary = this.querySelector('[data-lamy-ss-summary]');
        if (summary) {
          if (inCount > 0) {
            summary.dataset.state = 'in';
            summary.textContent = (this.dataset.summarySome || '').replace('[n]', String(inCount));
          } else if (unknown > 0) {
            summary.dataset.state = 'call';
            summary.textContent = this.dataset.summaryUnknown || '';
          } else {
            summary.dataset.state = 'out';
            summary.textContent = this.dataset.summaryNone || '';
          }
        }

        const updated = this.querySelector('[data-lamy-ss-updated]');
        if (updated) updated.hidden = stale;
      }
    }

    customElements.define('lamy-store-stock', LamyStoreStock);
  })();
  } catch(e) { console.error(e); }
})();

})();
